import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const apiCalls = {};

apiCalls.fetchTitles = async () => {
    const { data } = await api.get('/titles');

    return data;
};

apiCalls.fetchTitle = async titleId => {
    const { data } = await api.get(`/titles/${titleId}`);

    return data;
};

apiCalls.createTitle = async payload => {
    const { data } = await api.post('/titles', payload);

    return data;
};

apiCalls.updateTitle = async (id, payload) => {
    const { data } = await api.put(`/titles/${id}`, payload);

    return data;
};

apiCalls.deleteTitle = async titleId => {
    const { data } = await api.delete(`/titles/${titleId}`);

    return data;
};

export const useTitle = (titleId, queryOptions = {}) => useQuery(['title', titleId], () => apiCalls.fetchTitle(titleId), {
    cacheTime: 0,
    ...queryOptions
});

export const useTitles = (queryOptions = {}) => useQuery('titles', apiCalls.fetchTitles, queryOptions);

export const useUpdateTitle = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ id, payload }) => apiCalls.updateTitle(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('titles');
        },
        ...queryOptions
    });
};

export const useCreateTitle = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.createTitle(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('titles');
        },
        ...queryOptions
    });
};

export const useDeleteTitle = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(titleId => apiCalls.deleteTitle(titleId), {
        onSuccess: () => {
            queryClient.invalidateQueries('titles');
        },
        ...queryOptions
    });
};
